
<template>
  <section class="bg-white ">
    <div class="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 sm:py-16 lg:px-6">
      <!-- Row -->
      <div class="grid items-center gap-8 lg:grid-cols-2 xl:gap-16 md-max:max-w-lg md-max:m-auto">
        <div class="sm:text-lg  md-max:order-[2]">

          <h2 class="mb-4 font-extrabold h2">
            What Makes Rony Lavan's Traceable Peruvian Microlot Coffee So Special?
          </h2>

          <ul class="mt-10 space-y-4">
            <li class="flex space-x-3">
              <SvgCheck :color="'#507c93'"/>

              <span class="textp -mt-0.5"><strong class="text-lg">Farm-Level Traceability: </strong>

              Embrace the connection to the land and the people who work it, knowing that your coffee's journey is meticulously documented from the very farm it was grown.

              </span></li>

            <li class="flex space-x-3">
              <SvgCheck :color="'#507c93'"/>

              <span class="textp -mt-0.5"><strong class="text-lg">Uncompromising Quality: </strong>

             Delight in the rich, complex flavors resulting from a harmonious blend of Catimor, Caturra, Bourbon, and Typica varieties, all carefully selected for their exquisite taste.


              </span></li>


          </ul>

        </div>
        <nuxt-img class="w-full mb-4 rounded-lg lg:mb-0 lg:flex"
                  width="584"
                  height="400"
                  loading="lazy"
                  format="webp"
                  sizes="xs:330px sm:440px md:600px lg:720px xl:584px 2xl:584px"
                  src="/assets/images/indonesia-people.jpg" alt="indonesia people" />

      </div>
      <!-- Row -->
      <div class="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16 md-max:max-w-lg md-max:m-auto">
        <nuxt-img class="w-full mb-4 rounded-lg lg:mb-0 lg:flex"
             src="/assets/images/indonesia-5.jpg"
             width="584"
             height="351"
             loading="lazy"
             format="webp"
             sizes="sm:440px md:600px lg:720px xl:584px"
             alt="cajamarca plant"/>
        <div class="sm:text-lg ">

          <ul class="space-y-4">

            <li class="flex space-x-3">
              <SvgCheck :color="'#507c93'"/>

              <span class="textp -mt-0.5"><strong class="text-lg">Fair Prices for Producers: </strong>

             Stand in solidarity with coffee farmers like Rony Lavan, who receive the highest prices for their labor of love, empowering them to continue their passionate pursuit of excellence.



              </span></li>

            <li class="flex space-x-3">
              <SvgCheck :color="'#507c93'"/>

              <span class="textp -mt-0.5"><strong class="text-lg">Sustainable Practices: </strong>

            Support an eco-friendly future by choosing coffee that's not only certified organic, but also nurtures the environment and the communities it serves.


              </span></li>

            <li class="flex space-x-3">
              <SvgCheck :color="'#507c93'"/>

              <span class="textp -mt-0.5"><strong class="text-lg">Rony Lavan's Vision: </strong>

            Celebrate the inspiring journey of a man who transformed his love for coffee into a thriving business that champions both quality and fairness.



              </span></li>

          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped></style>


<script setup>

defineBuilderComponent({
    friendlyName: 'Content_Section_3',
    ignored: true
})

</script>